//src/components/templates/anamnese/FiltroAnamneses.js 
import React, { useState } from 'react';
import { Search, XCircle as ClearIcon } from 'lucide-react';

const FiltroAnamneses = ({ onFilterSubmit, loading }) => {
    const [nome, setNome] = useState('');

    const onSubmit = e => {
        e.preventDefault();
        onFilterSubmit({ nome });
    };

    const handleClear = () => {
        setNome('');
        onFilterSubmit({});
    };

    return (
        <form onSubmit={onSubmit} noValidate className="filter-form">
            <div className="form-group">
                <label htmlFor="filtro-nome">Nome do Template</label>
                <input 
                    type="text" 
                    id="filtro-nome" 
                    name="nome" 
                    placeholder="Buscar por nome..." 
                    value={nome} 
                    onChange={e => setNome(e.target.value)} 
                    className="form-input" 
                />
            </div>
            <div className="form-actions">
                <button type="button" onClick={handleClear} className="action-button action-button-secondary" disabled={loading || !nome}>
                    <ClearIcon size={18} className="icon"/> Limpar
                </button>
                <button type="submit" className="action-button action-button-primary" disabled={loading}>
                    <Search size={18} className="icon"/> {loading ? 'Buscando...' : 'Buscar'}
                </button>
            </div>
        </form>
    );
};

export default FiltroAnamneses;